import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f3a4a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = { class: "container p-lg-5 p-3" }
const _hoisted_3 = { class: "fw-bold mb-4 text-center" }
const _hoisted_4 = { class: "fs-6 fw-bold mb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_9 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-3 mb-lg-0" }
const _hoisted_10 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import ErrorMessage from '@/components/error-message'
import communityServices from '@/services/communities.service'
//TODO: SK40


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const loadingLeave = ref<boolean>(false)
const leaveError = ref<boolean>(false)

const transitToFinish = async () => {
  loadingLeave.value = true
  try {
    const response = await communityServices.leaveCommunityApi(route?.params?.id)
    if (response?.status === 200) {
      router.push(`/${route?.path?.split('/')[1]}/communities/leave_community_finished`)
      leaveError.value = false
    } else {
      leaveError.value = true
    }
    setTimeout(() => {
      loadingLeave.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    leaveError.value = false
    loadingLeave.value = false
  }
}
const backToSetting = () => {
  router.push(`/${route?.path?.split('/')[1]}/communities/${route?.params?.id}/account/profile/setting`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(translate)('SK40withdrawal')), 1),
      (leaveError.value)
        ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
            key: 0,
            title: _unref(translate)('SK40leaveError')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translate)('SK40notice')), 1),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_unref(translate)('SK40noticeFirst')), 1),
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_unref(translate)('SK40noticeFirst2')), 1)
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createTextVNode(_toDisplayString(_unref(translate)('SK40noticeSecond')) + " ", 1),
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_unref(translate)('SK40noticeSecond2')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Button, {
            title: _unref(translate)('back'),
            type: 'secondary',
            onClick: backToSetting,
            className: 'fw-bold'
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Button, {
            title: _unref(translate)('withdraw2'),
            type: 'secondary',
            onClick: transitToFinish,
            loading: loadingLeave.value,
            disabled: loadingLeave.value,
            className: 'fw-bold'
          }, null, 8, ["title", "loading", "disabled"])
        ])
      ])
    ])
  ]))
}
}

})